import { render, staticRenderFns } from "./EmployeeProfile.vue?vue&type=template&id=25623ca1&scoped=true&"
import script from "./EmployeeProfile.vue?vue&type=script&lang=js&"
export * from "./EmployeeProfile.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeProfile.vue?vue&type=style&index=0&id=25623ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25623ca1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25623ca1')) {
      api.createRecord('25623ca1', component.options)
    } else {
      api.reload('25623ca1', component.options)
    }
    module.hot.accept("./EmployeeProfile.vue?vue&type=template&id=25623ca1&scoped=true&", function () {
      api.rerender('25623ca1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/profile/EmployeeProfile.vue"
export default component.exports